import { render, staticRenderFns } from "./技术支持.vue?vue&type=template&id=07805792&scoped=true&"
import script from "./技术支持.vue?vue&type=script&lang=js&"
export * from "./技术支持.vue?vue&type=script&lang=js&"
import style0 from "./技术支持.vue?vue&type=style&index=0&id=07805792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07805792",
  null
  
)

export default component.exports